const PlayerStatisticsTypes = {
    GET_PLAYER_STATISTICS_START:'GET_PLAYER_STATISTICS_START',
    GET_PLAYER_STATISTICS_SUCCESS:'GET_PLAYER_STATISTICS_SUCCESS',
    GET_PLAYER_STATISTICS_FAILED:'GET_PLAYER_STATISTICS_FAILED',

}

export default PlayerStatisticsTypes